import { render, staticRenderFns } from "./PhotoValidationModal.vue?vue&type=template&id=8b8cfe1e&scoped=true"
import script from "./PhotoValidationModal.vue?vue&type=script&lang=js"
export * from "./PhotoValidationModal.vue?vue&type=script&lang=js"
import style0 from "./PhotoValidationModal.vue?vue&type=style&index=0&id=8b8cfe1e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b8cfe1e",
  null
  
)

export default component.exports